<template>
  <v-text-field
    v-if="definition.type === 'date'"
    :value="value"
    type="date"
    :label="label"
    hide-details
    class="fin-field"
    @input="emit"
  ></v-text-field>

  <v-text-field
    v-else-if="definition.type === 'month'"
    :value="value"
    type="month"
    :label="label"
    hide-details
    class="fin-field"
    @input="emit"
  ></v-text-field>

  <v-select
    v-else-if="definition.type === 'select'"
    :value="value"
    :items="optionItems"
    item-text="text"
    item-value="value"
    :label="label"
    hide-details
    class="fin-field"
    @input="emit"
  ></v-select>

  <v-select
    v-else-if="definition.type === 'multi_select'"
    :value="multiValue"
    :items="optionItems"
    item-text="text"
    item-value="value"
    :label="label"
    multiple
    chips
    small-chips
    hide-details
    class="fin-field"
    @input="emitMulti"
  ></v-select>

  <v-checkbox
    v-else-if="definition.type === 'bool'"
    :input-value="value"
    :label="label"
    hide-details
    class="fin-field"
    @change="emit"
  ></v-checkbox>

  <v-text-field
    v-else-if="definition.type === 'number' || definition.type === 'entity'"
    :value="value"
    type="number"
    :label="label"
    hide-details
    clearable
    class="fin-field"
    @input="emit"
  ></v-text-field>

  <v-text-field
    v-else
    :value="value"
    :label="label"
    hide-details
    clearable
    class="fin-field"
    append-icon="search"
    @input="emit"
  ></v-text-field>
</template>

<script>
/*
 * One filter control, rendered entirely from the server's filter metadata
 * (requirements doc 2026-09-09).
 *
 * Fifty reports declare their own filters in PHP; none of them needs markup
 * here. Adding a filter to a report is a line in its definition, not a change
 * to this file.
 */
export default {
  name: "ReportFilterField",
  props: {
    definition: { type: Object, required: true },
    value: { default: null },
  },
  computed: {
    label() {
      return this.definition.label_ar || this.definition.label_en || this.definition.key;
    },
    /** The server sends options as a plain value => Arabic label map. */
    optionItems() {
      const options = this.definition.options || {};
      return Object.keys(options).map((key) => ({
        value: key,
        text: options[key],
      }));
    },
    multiValue() {
      if (Array.isArray(this.value)) {
        return this.value;
      }
      return this.value ? String(this.value).split(",") : [];
    },
  },
  methods: {
    emit(next) {
      this.$emit("input", next);
    },
    /** Multi-selects travel as a comma-separated list, as the engine expects. */
    emitMulti(next) {
      this.$emit("input", (next || []).join(","));
    },
  },
};
</script>
